export enum PAYMENT_PLAN {
  FREE = 'FREE',
  REVENUE = 'REVENUE',
  CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS',
  PRODUCT = 'PRODUCT',
  CUSTOM = 'CUSTOM',
  // Legacy plans
  STARTUP = 'STARTUP',
  GROWTH = 'GROWTH',
}

export interface Plan {
  planId: number;
  type?: 'TRIAL';
  cancelUrl: string;
  status: 'active' | 'cancelled';
  maxSessions: number | null;
  baseUsers: number | null;
  baseProactiveCalls: number | null;
  baseReactiveCalls: number | null;
  baseTakeovers: number | null;
  baseSpyViewings: number | null;
  baseSixsenseCompanyDetailFetches: number | null;
  sixsenseData: object;
  multiOrg: boolean | null;
  sessionRecording: boolean | null;
  displayshare: boolean | null;
  displaydemo: boolean | null;
  kind: PAYMENT_PLAN;
  hasStripeSubscription: boolean;
  stripeSubscriptionId?: string;
  enforceUsageLimits: boolean;
}
